import { jsx } from "panel";
import { BannerEl } from "common/components/banner";
import { BannerAction, BannerSize, BannerType } from "common/components/banner/types";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".sharing-banner"
  }, this.helpers.shouldShow() ? /* @__PURE__ */ jsx(BannerEl, {
    attrs: {
      elref: `shareBanner`,
      theme: `info`,
      type: BannerType.Embedded,
      size: BannerSize.Small,
      "body-text": this.helpers.getShareBannerText(),
      ctas: window.localStorage && [{ text: `Dismiss`, actionName: BannerAction.Dismiss }],
      "style-override": `
          .banner-wrapper .banner-panel {padding: 8px;}
          .banner-wrapper .banner-panel .banner-actions {margin-bottom: 0}
          .banner-wrapper .banner-panel .banner-copy {margin-bottom: 0}
          .banner-wrapper .banner-panel .banner-actions .cta-button.banner-action-button-embedded.info-theme {border: none;}
        `
    },
    on: { action: this.helpers.handleBannerAction }
  }) : null);
}
